































import TitleBar from '@/components/titleBar/TitleBar.vue';
import IExternalStorageApiModel from '@/model/api/externalStorage/IExternalStorageApiModel';
import container from '@/model/ModelContainer';
import ISnackbarState from '@/model/state/snackbar/ISnackbarState';
import DateUtil from '@/util/DateUtil';
import { Component, Vue } from 'vue-property-decorator';
import * as apid from '../../../api';

@Component({ components: { TitleBar } })
export default class MoveJobs extends Vue {
    public jobs: apid.ExternalStorageMoveJob[] = [];
    public cancellingId: string | null = null;

    private api = container.get<IExternalStorageApiModel>('IExternalStorageApiModel');
    private snackbar = container.get<ISnackbarState>('ISnackbarState');
    private pollTimer: number | null = null;

    public async created(): Promise<void> {
        await this.reload();
        this.startPoll();
    }

    public beforeDestroy(): void {
        this.stopPoll();
    }

    public async reload(): Promise<void> {
        try {
            const res = await this.api.listMoveJobs();
            this.jobs = res.items;
        } catch (err) {
            this.snackbar.open({ color: 'error', text: 'ジョブ一覧取得失敗' });
        }
    }

    private startPoll(): void {
        this.stopPoll();
        this.pollTimer = window.setInterval(() => {
            const hasActive = this.jobs.some(j => j.status === 'running' || j.status === 'pending');
            // 進行中があれば 2 秒間隔、無ければ 15 秒間隔 (静かに)
            if (hasActive || this.jobs.length === 0) {
                this.reload();
            }
        }, 2000);
    }

    private stopPoll(): void {
        if (this.pollTimer !== null) {
            window.clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }

    public percent(job: apid.ExternalStorageMoveJob): number {
        if (job.total === 0) return 0;
        return Math.round((job.processed / job.total) * 100);
    }

    public statusLabel(s: apid.ExternalStorageMoveJob['status']): string {
        switch (s) {
            case 'pending':
                return '待機中';
            case 'running':
                return '実行中';
            case 'completed':
                return '完了';
            case 'cancelled':
                return 'キャンセル';
            case 'error':
                return '失敗';
        }
        return s;
    }

    public statusColor(s: apid.ExternalStorageMoveJob['status']): string {
        switch (s) {
            case 'pending':
                return 'grey';
            case 'running':
                return 'primary';
            case 'completed':
                return 'success';
            case 'cancelled':
                return 'warning';
            case 'error':
                return 'error';
        }
        return 'grey';
    }

    public canCancel(job: apid.ExternalStorageMoveJob): boolean {
        return job.status === 'pending' || job.status === 'running';
    }

    public async cancel(job: apid.ExternalStorageMoveJob): Promise<void> {
        this.cancellingId = job.id;
        try {
            await this.api.cancelMoveJob(job.id);
            this.snackbar.open({ color: 'success', text: 'キャンセル要求を送信' });
            await this.reload();
        } catch (err: any) {
            this.snackbar.open({ color: 'error', text: `キャンセル失敗: ${err?.response?.data?.message ?? err.message ?? ''}` });
        } finally {
            this.cancellingId = null;
        }
    }

    public formatTime(ms: number | null | undefined): string {
        if (!ms) return '';
        return DateUtil.format(DateUtil.getJaDate(new Date(ms)), 'MM/dd(w) hh:mm:ss');
    }
}
